    const getDate = (term) => {
        if(term === undefined) { return; }
        let date = new Date(term.date);
        date.setHours(term.hour.split(":")[0]);
        date.setMinutes(term.hour.split(":")[1]);
        return  date;
    };

    const getDateWithBufor = (date,bufor) => {
        if(date === undefined) { return; }
        date.setTime(date.getTime() + bufor*60000);
        return date;
    };

    export {getDate, getDateWithBufor};